exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".label {\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    }\n    .label-primary {\n        background-color: #337ab7!important;\n        }\n        .label {\n            display: inline;\n            padding: .2em .6em .3em;\n            font-size: 75%;\n            font-weight: 700;\n            line-height: 1;\n            color: #fff;\n            text-align: center;\n            white-space: nowrap;\n            vertical-align: baseline;\n            border-radius: .25em;\n            margin-right:10px;\n            }\n            .label-default {\n                background-color: #777;\n                }\n                .label-warning {\n                    background-color: #f0ad4e!important;\n                    }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/demo-users/demo-users.component.css
// module id = 160
// module chunks = 0